import { render, staticRenderFns } from "./DetailRecipient.vue?vue&type=template&id=1cd85123"
import script from "./DetailRecipient.vue?vue&type=script&lang=js"
export * from "./DetailRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports